<template>
  <div :class="['card-container-mem', member.is_expire?'card-exp':'']" @click="onClickMember">
    <div class="title">{{member.title}} | {{member.sub_desc}}</div>
    <div class="description">
      <div class="desc">{{member.desc}}</div>
      <div class="sub-desc" v-if="member.exp_sub_desc">{{member.exp_sub_desc}}</div>
      <div v-if="member.is_expire" class="exp-icon"> ></div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "MemberCard",
    props: {
      member: {
        type: Object,
        value: {}
      }
    },
    data() {
      return {}
    },
    methods: {
      onClickMember() {
        if (this.member.is_expire) {
          this.$router.push("/cashier")
        }
      }
    },
  }
</script>

<style lang="scss" scoped>
  .card-container-mem {
    -webkit-border-radius: 8px;
    -moz-border-radius: 8px;
    border-radius: 8px;
    background: rgba(0, 0, 0, 0.89);
    color: #f6b539;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px 18px;
  }

  .title {
    flex: 0 0 auto;
  }

  .card-exp {
    background: rgba(0, 0, 0, 0.89);
    color: white;
  }

  .description {
    display: flex;
    align-items: center;

    .desc {
      flex: 0 0 auto;
      padding: 0 8px;
    }

    .sub-desc{
      margin-left: 8px;
      color: #f6b539;
    }

  }

  .exp-icon {
    padding: 0 6px;
  }
</style>
